import React, { Component } from 'react';
import { render } from 'react-dom';
import $ from 'jquery';
import logo from '../../logo.svg';
import './App.css';
import Header from '../common/header';
import Footer from '../common/footer';
import Home from '../home';
import About from '../about';
import Director from '../directors';
import UnderProd from '../under_prod';
import Gallery from '../gallery';
import Service from '../services';
import SocMedia from '../soc_media';
import Contact from '../contact';
import PropTypes from 'prop-types';
import history from '../../history';



import {
BrowserRouter as Router,
  Route,
  Link,
  IndexRoute,
  Switch,
  Redirect
} from 'react-router-dom';


const baseUrl = process.env.PUBLIC_URL;

class App extends Component {

  
  constructor(props) {
       super(props);
  
       this.state = {
          activeUrl:'ratfilms.in',
          items:'this is appvalue',
          
       };
   }


   

  componentDidMount(){


    }

  render() {
    return (
      <Router history={history}>
        <div>
        <Header />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/about" component={About}  />
            <Route exact path="/directors" component={Director} />
            <Route exact path="/under_production" component={UnderProd} />
            <Route exact path="/services" component={Service} />
            <Route exact path="/social_media" component={SocMedia} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/gallery" component={Gallery} />
          </Switch>
        <Footer />
      </div>
    </Router>   
   );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/app/App.js